import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {UserRegistrationRedirectService} from '@app/services/user-registration/user-registration-redirect.service';
import {UserRegistrationConfigService} from '@app/services/user-registration/user-registration-config.service';
import {DcpUserService} from '@app/services/user/dcp-user.service';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {DcpCustomerRegistrationDecoratorService} from '@app/services/dcp-customer-registration-decorator.service';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';
import {CommercialModelService, ICommercialModelConfig} from '@dcp/configurator';
import {User} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class UserRegistrationGuard {
  constructor(
    private router: Router,
    private userRegistrationConfigService: UserRegistrationConfigService,
    private userRegistrationRedirectService: UserRegistrationRedirectService,
    private userService: DcpUserService,
    private authService: DcpAuthService,
    private customerRegistrationService: DcpCustomerRegistrationDecoratorService,
    private commercialModelService: CommercialModelService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([
      this.customerRegistrationService.getCurrentUser(),
      this.commercialModelService.getCommercialModelConfig(
        route.queryParamMap.get('action') || TransactionTypeCode.ORDER_NEW
      ),
      this.authService.isUserLoggedIn(),
    ]).pipe(
      take(1),
      switchMap(([user, commercialModelConfig, isLoggedIn]: [User, ICommercialModelConfig, boolean]) =>
        this.userService.isCustomerKnown(user).pipe(
          map((isCustomerKnown) => {
            if (isLoggedIn && commercialModelConfig.isFullRegistrationRequired && !isCustomerKnown) {
              this.userRegistrationConfigService.fetchConfigFromUrl(route);
              this.userRegistrationRedirectService.saveCurrentNavigationUrl(state);
              return this.router.parseUrl('/selectionType');
            }
            return true;
          })
        )
      )
    );
  }
}
